import { Component, type ErrorInfo, type ReactNode } from 'react';

type ErrorBoundaryProps = Readonly<{
  children: ReactNode;
}>;

type ErrorBoundaryState = Readonly<{
  hasError: boolean;
}>;

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled application error', error, info);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="error-state" role="alert">
          <h1>페이지를 표시할 수 없습니다.</h1>
          <p>잠시 후 다시 시도해 주세요.</p>
          <a href="/">홈으로 이동</a>
        </main>
      );
    }

    return this.props.children;
  }
}
